export const ps = {
  title: 'په تیرو درو کلونو کې پر ښځو د طالبانو د بندیزونو بېلګې',
  intro:
    'طالبانو په لومړیو کې د شریعت په چوکاټ کې د ښځو حقونو ته د درناوي ژمنه کړې وه خو واک ته له رسېدو وروسته يې داسي فرمانونه صادر کړل چې په دوامداره توګه یې د ښځو پر زده کړو، کار، ټولنیز او سیاسي فعالیت او سفر په برخو کې بندیزونه وضع کړل. د دغو بندیزونو یو شمېر بلیګې دلته وګورئ.',
  timeline: {
    title: 'د پېښو مهالوېش',
    hint: 'د نورو جزیاتو لپاره، په مهالوېش کې پر پېښو کلیک وکړئ',
  },
  footer: {
    followUs: 'راسره ملګري شئ',
    copyright: 'د دې سایټ د ټولو مطالبو حقوق له ازادي راډیو سره خوندي دي',
    aboutTitle: 'د راپور په اړه',
    about: ['راپور: ملالۍ بشیر', 'ډيزاین: پنجیا ډېټا ویز ټيم'],
    social: {
      instagram: 'https://www.instagram.com/azadiradio_pa/',
      youtube: 'https://www.youtube.com/user/Azadiradio',
      x: 'https://twitter.com/pazadiradio',
      facebook: 'https://www.facebook.com/azadiradio',
    },
  },
}
